<template>
<div>
  <v-card class="transparent elevation-0">
    <v-container container--fluid grid-list-md>
      <v-row>
        <v-col cols="12" :class="{'text-center': $vuetify.breakpoint.smAndDown}">
          <h1>AWS Jobs</h1>
        </v-col>
      </v-row>
      <v-row :justify="$vuetify.breakpoint.smAndDown ? 'center' : 'space-between'">
        <v-col cols="8" sm="4" md="3">
          <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
        </v-col>
        <div style="display: flex; justify-content: center; align-items: center">
          <v-btn text @click="refresh" >
            <v-icon color="cyan darken-2">refresh</v-icon>
          </v-btn>
        </div>
        <v-col cols="8" sm="4" md="3">
        </v-col>
      </v-row>
    </v-container>

    <v-divider></v-divider>

    <v-data-table
      :headers="headers"
      :search="search"
      :loading="loading"
      :items="renderedjobs"
      :expanded.sync="expanded"
      show-expand single-expand
      class="elevation-1"
      @item-expanded="expandRow"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:item="{item,index,expand,isExpanded}">
        <tr v-bind:class="{odd: index % 2, even: !index % 2}" >
          <td style="text-align: center" v-if="header.text !== 'Show runs'" v-for="(header, index) in headers" :key="index">
            {{item[header.value]}}
          </td>
          <td v-else  class="text-center">
            <v-tooltip   top color="secondary">
              <template v-slot:activator="{ on }">
                <v-icon color="green" @click.stop="confirmRerunb(item)" v-on="on">
                  autorenew
                </v-icon>
              </template>
              <span>rerun job</span>
            </v-tooltip>
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-icon v-if="isExpanded" color="blue" @click="expand(!isExpanded)" v-on="on">
                  keyboard_arrow_up
                </v-icon>
                <v-icon v-else color="blue" @click="expand(!isExpanded)" v-on="on">
                  keyboard_arrow_down
                </v-icon>
              </template>
              <span>Expand row</span>
            </v-tooltip>
          </td>
          <td v-else>
          </td>
        </tr>
      </template>
      <template v-slot:expanded-item="{ headers }">

        <td :colspan="headers.length" class="pa-0">
          <v-tabs
            v-model="tabRow"
            background-color="transparent"
            color="blue"
            grow
            slider-color="cyan accent-4"
          >
            <v-col cols="4" sm="8" md="4" class="text-center">
              <v-tab key="0">
                <v-icon class="mr-4">fas fa-table</v-icon>
                Created By
              </v-tab>
            </v-col>
            <v-col cols="4" sm="8" md="4" class="text-center">
              <v-tab key="1">
                <v-icon class="mr-4">fas fa-table</v-icon>
                Params
              </v-tab>
            </v-col>
              <v-col cols="4" sm="8" md="4" class="text-center">
                <v-tab key="2">
                  <v-icon class="mr-4">fas fa-table</v-icon>
                  results
                </v-tab>

             </v-col>
            <v-col cols="4" sm="2" md="1" class="text-center"></v-col>
          </v-tabs>
          <v-tabs-items v-model="tabRow" touchless>
            <v-tab-item :key="0">
              <v-card>
                <v-row justify="space-between" align="center">
                  <v-col cols="4" sm="2" md="1" class="text-center"></v-col>
                  <v-col cols="4" sm="10" md="5" class="text-center">
                    <v-row :justify="$vuetify.breakpoint.smAndDown ? 'center' : 'space-between'">
                      <div class="vertical-data">
                        <div v-for="(value,key) in createdInfo" :key="key" class="vertical-data-items">
                          <span class="item-key">{{key}}:</span> {{value}}
                        </div>
                      </div>
                    </v-row>
                  </v-col>
                  <v-col cols="4" sm="2" md="1" class="text-center"></v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item :key="1">
              <v-card>
                <v-row justify="space-between" align="center">
                  <v-col cols="4" sm="2" md="1" class="text-center"></v-col>
                  <v-col cols="4" sm="10" md="5" class="text-center">
                    <v-row :justify="$vuetify.breakpoint.smAndDown ? 'center' : 'space-between'">
                      <div class="vertical-data">
                        <div v-for="(value,key) in params" :key="key" class="vertical-data-items">
                          <span class="item-key">{{key}}:</span> {{value}}
                        </div>
                      </div>
                    </v-row>
                  </v-col>
                  <v-col cols="4" sm="2" md="1" class="text-center"></v-col>
                </v-row>


              </v-card>

            </v-tab-item>
            <v-tab-item :key="2">
              <v-card>
                <v-row justify="space-between" align="center">
                  <v-col cols="4" sm="2" md="1" class="text-center"></v-col>
                  <v-col cols="4" sm="10" md="5" class="text-center">
                    <v-row :justify="$vuetify.breakpoint.smAndDown ? 'center' : 'space-between'">
                      <div class="vertical-data">
                        <div v-for="(value,key) in results" :key="key" class="vertical-data-items">
                          <span class="item-key">{{key}}:</span> {{value}}
                        </div>
                      </div>
                    </v-row>
                  </v-col>
                  <v-col cols="4" sm="2" md="1" class="text-center"></v-col>
                </v-row>
              </v-card>
            </v-tab-item>
          </v-tabs-items>

        </td>
      </template>
    </v-data-table>
  </v-card>

  <v-dialog
    v-model="confirmDialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title class="text-center">
        Are you sure you want to confirm this rerun?
      </v-card-title>
      <v-card-text>
        <v-text-field hint="Job Id" v-model="jobId"></v-text-field>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn text color="blue-grey lighten-2" @click="confirmDialog = false">No</v-btn>
        <v-btn text @click="rerunjob" color="blue darken-1">Yes</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</div>
</template>

<script>
import axios from "axios";

export default {
  name: "Jobs",
  data (){
    return {
      tab: 0,
      tabRow:0,
      search: '',
      loading: false,
      pagination: {rowsPerPage: 10},
      reload: false,
      headers: [
        {text: 'Id', value: 'id', align: 'center', sortable: true},
        {text: 'Created', value: 'created', align: 'center', sortable: true},
        {text: 'Last Edit', value: 'last_edit', align: 'center', sortable: false},
        {text: 'Action', value: 'action', align: 'center', sortable: false },
        {text: 'Status', value: 'status_text', align: 'center', sortable: false },
        {text: 'Show runs', value: 'data-table-expand', align: 'center', sortable: false, width:'10%' },
      ],
      confirmDialog:false,
      showDialog: false,
      expanded: [],
      createdInfo:null,
      params:null,
      results:null,
      jobId:null,
    }
  },
  methods:{
    refresh() {
      this.reload = !this.reload;
    },
    updateDataTable() {
      this.reload = !this.reload;
    },
    expandRow(item) {
      this.createdInfo = item.item.created_by;
      this.params = item.item.params;
      this.results = item.item.results;

    },
    confirmRerunb(item){
      this.jobId = item.id;
      this.confirmDialog = true;
    },
    rerunjob(){
      if(this.jobId === null || this.jobId === undefined) {
        this.$store.commit('displaySnackbar', "Error job ID");
        return;
      }
      axios.post(process.env.API_URL + '/jobs/' + this.jobId + '/rerun', {})
        .then((response) => {
          this.$store.dispatch('displayJobDialog', response.data);
        })
        .catch((error) => {
          this.$store.commit('displaySnackbar', "Error while retrigger job");
        });
      this.confirmDialog = false;
    },
  },
  computed: {
    renderedjobs() {
      if (this.jobs === null || this.jobs === undefined) {
        return [];
      } else {
        return this.jobs.filter(item => item !== null && item !== undefined);
      }
    }
  },
  asyncComputed: {
    async jobs() {
      if (this.reload || !this.reload) {
        this.loading = true;
        return await axios.get(process.env.API_URL + '/jobs')
          .then((response) => {
            if (response.status === 200) {
              this.loading = false;
              return response.data;
            } else {
              this.loading = false;
              return [];
            }
          })
          .catch((error) => {
            this.loading = false;
            this.$store.commit('displaySnackbar', 'ERROR ' + error.response.data.error);
          });
      }
    },
  }
}
</script>

<style scoped>
.vertical-data{
  display: flex;
  flex-direction: column;
}
.vertical-data-items{
  margin-bottom: 10px;
  display: flex;
  align-items: flex-start;
}

.item-key{
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/Jobs.vue